<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <v-icon class="mr-2">{{ mdiClipboardCheckMultipleOutline }}</v-icon>
        Checklists
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select
              :items="checklists"
              item-text="name"
              v-model="value"
              label="Start checklist"
              return-object
            ></v-select>
            <v-btn :disabled="!value" @click="startChecklist" color="success">
              Start
            </v-btn>
            <ListChecklistTransaction></ListChecklistTransaction>
          </v-col>
          <v-col cols="6">
            <ListCheckList></ListCheckList>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mdiClipboardCheckMultipleOutline } from '@mdi/js';
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import ListCheckList from '../components/ListCheckList.vue';
import ListChecklistTransaction from '../components/ListChecklistTransaction.vue';

export default {
  name: 'Checklists',
  components: {
    ListCheckList,
    ListChecklistTransaction,
  },
  mixins: [loading],
  data() {
    return {
      mdiClipboardCheckMultipleOutline,
      value: undefined,
    };
  },
  computed: {
    ...mapState('checklists', ['checklists']),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('checklists', ['LOAD_checklists']),
    ...mapActions('checklistTransactions', ['CREATE_checklistTransaction']),
    ...mapActions('checklistTransactionItems', ['CREATE_checklistTransactionItems']),
    async refresh() {
      this.isLoading = true;
      await this.LOAD_checklists();
      this.isLoading = false;
    },
    async startChecklist() {
      console.debug(this.value);
      const result = await this.CREATE_checklistTransaction({ checklistId: this.value.id, state: 'Started' });
      this.$router.push({ name: 'checklists-Checklist', query: { id: result.id } });
    },
  },
};
</script>
